__turbopack_context__.v({
  "horizontalRule": "horizontalRule-module-scss-module__-kYtoW__horizontalRule",
});
